import React, { useContext, useEffect, useState } from 'react';
import { AudioContext } from '../../libs/audio-provider';
import { BackgroundContext } from '../../libs/BackgroundProvider';
import { useGameContext } from "../../libs/GameProvider";
import CountDown from '../game-common/CountDown';
import LottieDiv from '../ui/LottieDiv';
import GamePaperMakingHintsAndDescriptionModal from './GamePaperMakingHintsAndDescriptionModal';
import GamePaperMakingPreGame from './GamePaperMakingPreGame';

interface GamePaperMakingGameProps {
  children?: React.ReactNode;
  style?: React.CSSProperties;
  onFinish?: () => void;
}

function GamePaperMakingGame(props: GamePaperMakingGameProps) {
  const { playClick } = useContext(AudioContext);
  const { setBg } = useContext(BackgroundContext);
  const { game, dispatch } = useGameContext();
  const [started, setStarted] = useState(false);
  // const [stopped, setStopped] = useState(false);
  const [lives, setLives] = useState(3);
  const [stepRandomPosition, setStepRandomPosition] = useState([1, 2, 3, 4, 5, 6].sort(() => .5 - Math.random()));
  const [barItemsState, setBarItemsState] = useState<Array<'ready' | 'fail' | 'success'>>(['ready', 'ready', 'ready', 'ready', 'ready', 'ready',]);
  const [paperIndex, setPaperIndex] = useState(0);
  const [currentStep, setCurrentStep] = useState(0);

  useEffect(() => {
    console.log(game);
    if ('game-paper-making' === game.status) {
      setBg(null);
    }
  }, [game, setBg]);

  useEffect(() => {
    console.log("next paper", paperIndex);
    setTimeout(() => {
      setCurrentStep(0);
      setStepRandomPosition([1, 2, 3, 4, 5, 6].sort(() => .5 - Math.random()));
      setBarItemsState(['ready', 'ready', 'ready', 'ready', 'ready', 'ready',]);
    }, 500);
  }, [paperIndex]);

  useEffect(() => {
    if (6 === currentStep) {
      setPaperIndex(o => o += 1);
    }
  }, [barItemsState]);

  useEffect(() => {
    console.log('currentStep', currentStep);
    if (0 !== currentStep) {
      setBarItemsState(o => {
        let n = [...o];
        n[currentStep - 1] = 'success';
        console.log(o, n, currentStep);
        return n;
      });
    }
  }, [currentStep]);

  const onStepClick = (stepIndex: number) => {
    playClick();
    // console.log(stepIndex, currentStep);
    if (stepIndex === 1 + currentStep) {
      setCurrentStep(o => 1 + o);
    } else {
      if (1 === lives) {
        // dispatch({ type: 'game-paper-making', state: 'fail' })
      } else {
        // setLives(l => l - 1);
        setBarItemsState(o => { let n = [...o]; n[currentStep] = 'fail'; console.log(o, n); return n; });
      }
    }
    // console.log(stepIndex, currentStep.current);
  }

  const timesout = () => {
    if (0 === paperIndex) {
      dispatch({ type: 'game-paper-making', state: 'fail', })
    } else {
      dispatch({ type: 'game-paper-making', state: 'success', data: paperIndex })
    }
  }

  const onIntroFinish = () => {
    setStarted(true);
  }

  console.log('paperIndex: ', paperIndex);
  return (
    <div className="fullscreen">
      <div>
        <CountDown started={started} stopped={false} timesout={timesout}></CountDown>

        <GamePaperMakingHintsAndDescriptionModal lives={lives} />

        <div className={`steps`}>
          {[1, 2, 3, 4, 5, 6].map(i =>
            <div key={i} className={`step step-${i} step-pos-${stepRandomPosition[i - 1]} step-state-${barItemsState[i - 1]} step-correct-${i === (1 + currentStep) ? 'true' : 'false'}`} onClick={() => onStepClick(i)}>
              <LottieDiv json={`game-paper-making/game1-step${i}`} imgFolder={`game-paper-making/game1-step1-6-character/game1-step${i}/images`}></LottieDiv>
            </div>)}
        </div>

        <div className="bar">
          {[1, 2, 3, 4, 5, 6].map(i => <div key={i} className={`bar-item bar-item-${i} bar-item-state-${barItemsState[i - 1]}`}></div>)}
        </div>

        <GamePaperMakingPreGame onFinish={onIntroFinish} />
      </div>
    </div>
  )
}

export default GamePaperMakingGame;
